export default "__VITE_ASSET__ob1w8wlq__"